import { Factory } from 'rosie';

Factory.define('ChannelsAdmin').attr('name', 'CHANNELS_ADMIN');

Factory.define('ChannelsAdminWithDefaults').extend('ChannelsAdmin');



// WEBPACK FOOTER //
// ./factories/location/channels_admin.js